var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticStyle:{"height":"6.25rem","overflow":"hidden"}},[_c('radar-spinner',{attrs:{"animation-duration":2000,"size":100,"color":"var(--color-secondary)"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }